import axios from "axios";
import APIS from "api/index";
import Qs from "qs";
import {
  Message,
} from 'iview';

var env = process.env.NODE_ENV;
// 超时时间

axios.defaults.timeout = 10000;
// http请求拦截器
axios.defaults.withCredentials = true;
// Access-Control-Allow-Origin:*
axios.defaults.mode = 'cors';

axios.interceptors.request.use(config => {
  if (config.method == 'post') {
    if (config.data.isJson) {
      delete config.data.isJson;
    } else {
      let data = Qs.stringify(config.data);
      config.data = data;
    }

  }
  // let apiUrl = '';
  // let HOST = process.env.HOST;
  // HOST = HOST === 'prod' ? 'api' :   HOST;
  // const local = window.location.host
  // if (local.includes('novoiot.com')) {
  //   apiUrl = `//api.novoiot.com`
  // } else if (local.includes('novoiot.cn')) {
  //   apiUrl = `//api.novoiot.cn`
  // } else {
  //   apiUrl = `//api.novoiot.cn`
  // }
  // apiUrl = '//'+HOST+".novoiot.com";
  config.baseURL = '/' // apiUrl;
  return config
}, error => {
  return Promise.reject(error)
})


function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}


function checkLogin(res, reject) {
  if (res && res.status && res.status >= 400) {
    const resData = res.data || {};
    if (resData.code && resData.code == 'NON_LOGIN') {

      const redirectUrl = encodeURIComponent(window.location.pathname + window.location.search);
      //跳转到登录页面
      window.location.href = `/login?ROUT=${redirectUrl}`;
    } else {
      Message.warning({
        content: resData.msg || '后台出错，请稍后重试',
        duration: 2
      });
      reject(res)
    }
  }
  return res;
}


function timeoutHandler() {
  axios.interceptors.response.use(function (response) {
    // 对响应数据做处理
    return response;
  }, function (error) {
    // 对响应错误做处理
    if (error.code === 'ECONNABORTED') {
      // Message.warning('请求超时，请稍后再试');
      // Message.info({
      //   content: 'I ll be gone in 10 seconds',
      //   duration: 10
      // });
    }
    return Promise.reject(error);
  });
}


export default {
  get: (url, params, success, failure) =>

    new Promise((resolve, reject) => {
      if (params) {

        params = Object.assign(params,{dateTime : new Date().getTime()});

        params = filterNull(params);
      }
      if (!APIS[url].url) {
        return;
      }
      timeoutHandler();
      axios
        .get(APIS[url].url, {
          params: params
        })
        .then(function (response) {
          resolve(response);

        })
        .catch(function (error) {


          if (error.code === 'ECONNABORTED') {
            Message.warning('请求超时，请稍后再试');

          } else if (error.response) {
            checkLogin(error.response, reject);
          }

          if (error && error.response && error.response.data) {
            error = error.response;
            failure && failure(error);
          }

        });
    }),
  post: (url, params, success, failure) =>

    new Promise((resolve, reject) => {
      if (params) {
        params = filterNull(params);
      }
      if (!APIS[url].url) {
        return;
      }
      timeoutHandler();
      axios
        .post(APIS[url].url, params)
        .then(function (response) {

          resolve(response);

        })
        .catch(function (error) {
          if (error.code === 'ECONNABORTED') {
            Message.warning('请求超时，请稍后再试');

          } else if (error.response) {
            checkLogin(error.response, reject);
          }

          if (error && error.response && error.response.data) {
            error = error.response;
            failure && failure(error);
          }
        });
    }),
  put: (url, params, success, failure) =>
    new Promise((resolve, reject) => {
      if (params) {
        params = filterNull(params);
      }
      if (!APIS[url].url) {
        return;
      }
      timeoutHandler();
      axios
        .put(APIS[url].url, params)

        .then(function (response) {
          resolve(response);

        })
        .catch(function (error) {

          if (error.code === 'ECONNABORTED') {
            Message.warning('请求超时，请稍后再试');

          } else if (error.response) {
            checkLogin(error.response, reject);
          }

          if (error && error.response && error.response.data) {
            error = error.response;
            failure && failure(error);
          }

        });
    }),
  delete: (url, params, success, failure) =>
    new Promise((resolve, reject) => {
      if (params) {
        params = filterNull(params);
      }
      if (!APIS[url].url) {
        return;
      }
      timeoutHandler();
      axios
        .delete(APIS[url].url, {
          params: params
        })
        .then(function (response) {

          resolve(response);
        })
        .catch(function (error) {

          if (error.code === 'ECONNABORTED') {
            Message.warning('请求超时，请稍后再试');

          } else if (error.response) {
            checkLogin(error.response, reject);
          }

          if (error && error.response && error.response.data) {
            error = error.response;
            failure && failure(error);
          }

        });
    })
};



// WEBPACK FOOTER //
// ./src/common/js/http.js